/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { GW } from '../lib/config.js';
import { PALETTE_HEX } from '../lib/palette.js';

export default {
  // Undo werkt per bewerking: we bewaren alleen de cellen die IK veranderde,
  // zodat ongedaan maken in duo de pixels van de ander niet weggooit en wel
  // bij de ander doorkomt.
  pushUndo() {
      if (!this.canvasRef.current) return;
      if (this.opBefore) this.commitOp();
      this.opBefore = this.duoEncode().split('');
    },

  commitOp() {
      const before = this.opBefore;
      this.opBefore = null;
      if (!before || !this.canvasRef.current) return;
      const after = this.duoEncode();
      if (after.length !== before.length) return;
      const cells = [];
      for (let i = 0; i < after.length; i++) if (after[i] !== before[i]) cells.push([i, before[i], after[i]]);
      if (!cells.length) return;
      this.undoStack.push({ k: 'cells', f: this.state.frameIdx || 0, cells });
      if (this.undoStack.length > 80) this.undoStack.shift();
      this.redoStack = [];
      this.syncHistory();
    },

  // Alle beelden zoals ze nu zijn, inclusief wat er op het doek staat. Hiermee
  // kan één stap ook een verandering over meerdere beelden ongedaan maken.
  snapDoc() {
      const frames = this.framesArr();
      frames[this.state.frameIdx || 0] = this.frameNow();
      return { frames, on: this.onArr(), idx: this.state.frameIdx || 0 };
    },

  pushDoc(before, after) {
      this.undoStack.push({ k: 'doc', before, after });
      if (this.undoStack.length > 80) this.undoStack.shift();
      this.redoStack = [];
      this.syncHistory();
    },

  async applyDoc(s) {
      clearTimeout(this.wipTimer);
      await this.drawDataUrl(s.frames[s.idx] || '');
      this.clearSel();
      await new Promise((done) => this.setState({
        frames: s.frames.slice(), frameOn: s.on.slice(), frameIdx: s.idx, playing: false
      }, () => {
        this.stashFirst(s.frames[0]);
        this.stashExtra(s.frames.slice(), s.on.slice(), true);
        this.snapshotCanvas();
        done();
      }));
    },

  // Ongedaan maken kan over de beelden heen: staat de stap in een ander beeld,
  // dan springen we daar eerst naartoe zonder de geschiedenis te wissen.
  async hopFrame(i) {
      const cur = this.state.frameIdx || 0;
      if (i === cur) return;
      clearTimeout(this.wipTimer);
      const frames = this.framesArr();
      const on = this.onArr();
      frames[cur] = this.frameNow();
      on[i] = true;
      await this.drawDataUrl(frames[i] || '');
      await new Promise((done) => this.setState({ frames, frameOn: on, frameIdx: i, playing: false }, () => {
        this.stashFirst(frames[0]);
        this.stashExtra(frames, on, true);
        this.snapshotCanvas();
        done();
      }));
    },

  applyCells(cells, which) {
      const ctx = this.getCtx();
      if (!ctx) return;
      cells.forEach((c) => {
        const ch = which === 'before' ? c[1] : c[2];
        const x = c[0] % GW, y = Math.floor(c[0] / GW);
        ctx.clearRect(x, y, 1, 1);
        const idx = parseInt(ch, 16);
        if (ch !== '.' && !isNaN(idx) && PALETTE_HEX[idx]) { ctx.fillStyle = PALETTE_HEX[idx]; ctx.fillRect(x, y, 1, 1); }
      });
    },

  syncHistory() {
      if (this.state.undoN !== this.undoStack.length || this.state.redoN !== this.redoStack.length) {
        this.setState({ undoN: this.undoStack.length, redoN: this.redoStack.length });
      }
    },

  // Een pad dat nog open staat, hoort eerst weg: anders zet het volgende
  // penbeeld de ongedaan gemaakte pixels gewoon terug.
  cancelPen() {
      this.penDragOff();
      if (!this.penPts) return;
      const ctx = this.getCtx();
      if (ctx && this.penBase) ctx.putImageData(this.penBase, 0, 0);
      this.penPts = null; this.penBase = null; this.penClosed = false; this.penDrag = null;
      this.opBefore = null;
      this.duoTick();
      this.setState({ drawing: false });
    },

  penUndo() {
      if (!this.penPts) return false;
      if (this.penPts.length > 1) {
        this.penPts.pop();
        this.penDrag = null;
        this.penDragOff();
        this.renderPen(null);
      } else {
        this.cancelPen();
      }
      return true;
    },

  async undo() {
      if (!this.tekentNu() || !this.canvasRef.current || this.frameBusy) return;
      if (this.penUndo()) return;
      if (this.opBefore) this.commitOp();
      if (!this.undoStack.length) return;
      const e = this.undoStack.pop();
      this.frameBusy = true;
      try {
        if (e.k === 'doc') {
          await this.applyDoc(e.before);
        } else {
          if (e.f != null) await this.hopFrame(e.f);
          this.applyCells(e.cells || e, 'before');
          this.clearSel();
          this.snapshotCanvas();
        }
      } finally {
        this.frameBusy = false;
      }
      this.redoStack.push(e);
      this.syncHistory();
    },

  async redo() {
      if (!this.tekentNu() || !this.canvasRef.current || !this.redoStack.length || this.frameBusy) return;
      const e = this.redoStack.pop();
      this.frameBusy = true;
      try {
        if (e.k === 'doc') {
          await this.applyDoc(e.after);
        } else {
          if (e.f != null) await this.hopFrame(e.f);
          this.applyCells(e.cells || e, 'after');
          this.clearSel();
          this.snapshotCanvas();
        }
      } finally {
        this.frameBusy = false;
      }
      this.undoStack.push(e);
      this.syncHistory();
    }
};
